import {
    ADD_AGENT_LOCAL,
    AGENT_TIMER_SUCCESS, 
} from '../actions/agent.js';


const initialState = {
    agentTask: {},
    survey: {},
    agentTaskMessage: {},
    surveyMessage: {},
    time:"00:00:00"
};
// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case ADD_AGENT_LOCAL: {
            return {
                ...state,
                agentTask: action.payload.data,
            };
        }

        case AGENT_TIMER_SUCCESS: {
            return {
                ...state,
                time: action.payload.data,
            };
        }

        default: {
            return {
                ...state,
            };
        }
    }
}
